import { persistReducer, persistStore } from 'redux-persist';
import { routerMiddleware } from 'react-router-redux';
import { createStore, applyMiddleware } from 'redux';
import storage from 'redux-persist/lib/storage';
import thunkMiddleware from 'redux-thunk';

import rootReducer from './rootReducer';
import apiMiddleware from './middlewares/api';
import tokenMiddleware from './middlewares/tokenRefresher';
import refresheableMiddleware from './middlewares/refresheable';

// middlewares par défaut
let middlewares = [thunkMiddleware, apiMiddleware, refresheableMiddleware, tokenMiddleware];

const enableDevTools =
    process.env.NODE_ENV !== 'production' &&
    window.__REDUX_DEVTOOLS_EXTENSION__ &&
    window.__REDUX_DEVTOOLS_EXTENSION__();

// A the moment, we persist nothing at the first level
// if you want to persist second level state, you need to put a similar thing in the reducer concerned
const persistConfig = {
    key: 'root',
    storage,
    whitelist: []
};

const reducers = persistReducer(persistConfig, rootReducer);

export const configureStore = history => {
    // include the history middleware with the history param
    middlewares = [...middlewares, routerMiddleware(history)];
    const store = createStore(reducers, enableDevTools, applyMiddleware(...middlewares));
    const persistor = persistStore(store);
    return { store, persistor };
};



// WEBPACK FOOTER //
// ./src/store.js